var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileTxt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M3.994 4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.994 2 6 6h-4a2 2 0 0 1-2-2z",
  opacity: 0.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.797 15.369v-.642h2.766v.642h-.992v2.63h-.78v-2.63zM11.38 14.727l.598 1.034h.026l.604-1.034h.885l-.988 1.636L13.525 18h-.908l-.614-1.046h-.025L11.364 18h-.901l1.015-1.637-.99-1.636zM7.43 15.369v-.642h2.766v.642h-.992v2.63h-.78v-2.63z"
})));
export default SvgFileTxt;